import React, {Component} from 'react';
import iconsSvg from '../../assets/img/svgLib/iconsSvg';
import PropTypes from 'prop-types';
import './Supply.scss';
import SupplyFullInfo from '../SupplyFullInfo/SupplyFullInfo';
import InformationCard from '../InformationCard/InformationCard';

class Supply extends Component {
  static propTypes = {
      supply: PropTypes.object,
      handleBack: PropTypes.func,
  }
  constructor(props) {
    super(props)

    this.state = {

    }
  }

  render() {
    const {supply} = this.props;
    const {supplyMore} = supply;
    const supplyPriceRate = Math.trunc(supplyMore.supplyPriceFinal / supplyMore.supplyInformation.supplyPrice * 100);

    return (
      <div className={'supplyContent'}>
        <div className={'firstBlock'}>
          <div className={'title'}>
            <div onClick={() => this.props.handleBack(false)}>
              {iconsSvg.back}
            </div>
            <div className={'tooltipSupplyName'}>
              Поставка
            </div>
            {supplyMore.supplyName}
          </div>
          <div className={'blockInfo'}>
            <div className={'dataSupplyBlock'}>
              <div className={'suppBlockItem'}>
                <div className={'digit'}>{supply.delayLeft}</div>
                <div className={'text'}>дней</div>
                <div className={'comment'}>Отсрочка осталось</div>
              </div>
              <div className={'suppBlockItem'}>
                <div className={'digit'}>{supplyMore.supplyInterestRate}</div>
                <div className={'text'}>%</div>
                <div className={'comment'}>Желаемая ставка, год</div>
              </div>
              <div className={'suppBlockItem'}>
                <div className={'digit'}>{supplyMore.supplyPriceFinal}</div>
                <div className={'text'}>руб.</div>
                <div className={'comment'}>Требуемая сумма финансирования</div>
              </div>
              <div className={'suppBlockItem'}>
                <div className={'digit'}>{supplyPriceRate}</div>
                <div className={'text'}>%</div>
                <div className={'comment'}>Стоимость поставки</div>
              </div>
            </div>
          </div>
        </div>
        <div className={'secondBlock'}>
          <div className={'fullInfoWidget'}>
            <SupplyFullInfo supply={this.props.supply}/>
          </div>
          <div className={'rightBlock'}>
            <div className={'btnGroup'}>
              <div className={'buttonElem'}>
                Добавить в портфель
              </div>
              <div className={'buttonElem'}>
                Отправить КП
              </div>
            </div>
            <div className={'infoCardWidget'}>
              <InformationCard supply={supply} viewType={'short'} roleUser={'debtor'}/>
            </div>
            <div className={'infoCardWidget'}>
              <InformationCard supply={supply} viewType={'short'} roleUser={'vendor'}/>
            </div>
          </div>
        </div>
      </div>
    )

  }
}

export default Supply



// WEBPACK FOOTER //
// ./src/shared/Supply/Supply.js